





























































import {
	computed,
	defineComponent,
	ref,
	watch,
} from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TrForm from '@front-app/components/form/Form.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import { Size } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';

export default defineComponent({
	components: {
		CtaButton,
		TrForm,
		FormInput,
	},
	props: {
		currentPage: {
			type: Number,
			required: true,
		},
		numPages: {
			type: Number,
			required: true,
		},
		hasNextPage: Boolean,
		hasPrevPage: Boolean,
	},
	setup(props) {
		const goToPage = ref(props.currentPage);
		watch(computed(() => props.currentPage), () => {
			goToPage.value = props.currentPage;
		});
		return {
			goToPage,
			Size,
			ButtonPalettes,
		};
	},
});
